import {useEffect,useState,useContext} from 'react'
import MySliser from '../Slider/Slider';
import Categories from '../Categories/Categories';
import Filter from '../Filter/Filter';
import { BrowserView, MobileView } from 'react-device-detect';
import { getAll } from '../../Data/Utils';
import { buildItemsList } from '../../Data/GeneralFanction';
import DataSet from '../DataSet/DataSet';

const AllCategoriesData = () => {

    const [ categoriesState,setCategoriesState]=useState([]);
// const [ categoryIdSelected,setCategoryIdSelected]=useState();

// const { language } = useContext(LanguageContext);

    useEffect(()=>{
        const getCtegories = async () => {
            const webUrl=window.srcSiteUrl;//process.env.REACT_APP_APIURL;
            const apiUrl=config.apiUrl;
            const categoriesList=config.lists.categories.name; 
            const view=config.lists.categories.view;
            let { data: categoriesAll } = await getAll(`${webUrl}${apiUrl}?listName=${categoriesList}&view=${view}`);
            var x=buildItemsList(categoriesAll);
            setCategoriesState(x) ;
      
        };
        var config = require('../../config.json');
      
          getCtegories();
      
      },[]);

  return (
    <>{ categoriesState.length>0 && <>
         <BrowserView> 
        <Categories categories={categoriesState}/>
        </BrowserView>
        <MobileView>
        <MySliser categories={categoriesState}/>
        </MobileView>
        <div role="tabpanel">
            <Filter categories={categoriesState}/>
            <DataSet/>
        </div>
        </>}
    </>
  )
}

export default AllCategoriesData